import { 
  ShieldCheck, 
  Link2, 
  Wallet, 
  Key, 
  Clock, 
  ArrowRight,
  CheckCircle2
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { CyberpunkBackground } from "./CyberpunkBackground";
import { CtaButton } from "@/components/CtaButton";

export function SecurityFeaturesSection() {
  const securityFeatures = [
    {
      icon: <Key className="h-8 w-8 text-[#14F195]" />,
      title: "Secure Private Key Management",
      description: "Your private keys remain exclusively with you. Our Solana Volume Bot operates without needing access to your sensitive keys, ensuring your crypto assets stay completely secure and under your direct control."
    },
    {
      icon: <Link2 className="h-8 w-8 text-[#14F195]" />,
      title: "No Wallet Connection Needed",
      description: "Experience safe and seamless volume boosting. You don't need to connect your cryptocurrency wallet directly to our platform, minimizing potential risks and enhancing security for your Solana tokens."
    },
    {
      icon: <Wallet className="h-8 w-8 text-[#14F195]" />,
      title: "Token Address Based Identification",
      description: "Enhance your security posture with our token address based identification. This method eliminates the need for traditional passwords, significantly reducing the security risks associated with credential theft and unauthorized access to your Solana Volume Bot account."
    },
    {
      icon: <Clock className="h-8 w-8 text-[#14F195]" />,
      title: "Flexible Campaign Control",
      description: "Gain complete control and security over your volume campaigns. Our service offers unparalleled flexibility, allowing you to start or stop your Solana token volume boosting efforts instantly with no long-term commitment or contracts required."
    }
  ];

  return (
    <section id="security" className="py-20 relative overflow-hidden">
      {/* Cyberpunk background */}
      <CyberpunkBackground variant="dark" withGrid withNoise withGlitch />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="flex justify-center mb-4">
            <div className="bg-[#14F195]/10 p-3 rounded-full">
              <ShieldCheck className="h-8 w-8 text-[#14F195]" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Solana Volume Bot <span className="text-[#14F195]">Security & Trust</span>
          </h2>
          <p className="text-gray-400 max-w-3xl mx-auto">
            Experience secure boosting of your Solana token's market visibility with our Solana Volume Bot. We prioritize your asset safety and secure volume distribution practices.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {securityFeatures.map((feature, index) => (
            <div
              key={index}
              className="bg-[#0c0c15] border border-[#1e2035] rounded-lg p-6 shadow-[0_0_30px_rgba(20,241,149,0.05)] hover:border-[#14F195]/30 transition-all duration-300"
            >
              <div className="bg-[#14F195]/10 p-3 rounded-lg inline-block mb-4">
                {feature.icon}
              </div>
              <h3 className="text-white text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="bg-[#0c0c15] border border-[#1e2035] rounded-lg p-8 mb-8 max-w-4xl mx-auto shadow-[0_0_30px_rgba(20,241,149,0.05)]">
          <div className="flex flex-col md:flex-row gap-6 items-center">
            <div className="bg-[#14F195]/10 p-4 rounded-full shrink-0">
              <CheckCircle2 className="h-10 w-10 text-[#14F195]" />
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold text-white mb-2">Token Visibility System</h3>
              <p className="text-gray-400 mb-0">
                Leveraging secure token address identification, simply enter your Solana token address and start boosting its market presence and volume visibility on decentralized exchanges securely.
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex justify-center mt-8">
          <CtaButton 
            size="lg" 
            variant="primary"
            className="px-6 py-3"
            icon={<ArrowRight className="ml-2 h-5 w-5" />}>
            Start Free Trial
          </CtaButton>
        </div>
      </div>
    </section>
  );
}